<span class="font-medium-title-large">{{ title }}</span>
<image-cropper
  [imageChangedEvent]="imageChangedEvent"
  [maintainAspectRatio]="true"
  [aspectRatio]="aspectRatio"
  [roundCropper]="roundCropper"
  [resizeToHeight]="height"
  [onlyScaleDown]="onlyScaleDown"
  [containWithinAspectRatio]="containWithinAspectRatio"
  [format]="format"
  [imageQuality]="92"
  (imageCropped)="imageCropped($event)"
  (imageLoaded)="imageLoaded()"
  (cropperReady)="cropperReady()"
  (loadImageFailed)="loadImageFailed()">
</image-cropper>
<div class="flex-r gap-16 justify-center padding-top-16">
  <button
    type="button"
    class="inwi-text-button-large-secondary"
    (click)="onCancel()">
    <div class="button-content">
      <div class="button-text">Abbrechen</div>
    </div>
  </button>
  <button
    type="button"
    (click)="onSave()"
    class="inwi-text-button-large-primary">
    <div class="button-content">
      <div class="button-text">Speichern</div>
    </div>
  </button>
</div>
